import { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import api from "../../api";
import calculatorImg from "../../images/calculator3.png";

export const RRRCalculator = () => {
  const alert = useAlert();
  const [data, setData] = useState({
    tradeType: "long",
  });
  const [loader, setLoader] = useState(false);

  const [response, setResponse] = useState({});

  const onTextChange = (e, investmentVal) => {
    if (investmentVal) {
      setData({ ...data, investment: investmentVal });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  function formatPrice(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: value < 1 ? 4 : 2,
      maximumFractionDigits: value < 1 ? 8 : 2,
    }).format(value);
  }

  function calculateRiskReward() {
    try {
      let entryPrice = data?.entryPrice;
      let slPrice = data?.slPrice;
      let tpPrice = data?.tpPrice;
      let tradeType = data?.tradeType;

      if (!entryPrice || !slPrice || !tpPrice) {
        throw new Error(
          "Missing required fields: entryPrice, slPrice, tpPrice"
        );
      }

      // Auto-detect trade direction (long/short)
      const isLong = tradeType
        ? tradeType.toLowerCase() === "long"
        : tpPrice > entryPrice;

      let risk, reward;

      if (isLong) {
        risk = entryPrice - slPrice;
        reward = tpPrice - entryPrice;
      } else {
        risk = slPrice - entryPrice;
        reward = entryPrice - tpPrice;
      }

      if (risk <= 0 || reward <= 0) {
        throw new Error("Invalid price setup, check SL/TP values.");
      }

      const riskRewardRatio = reward / risk;
      const breakevenWinRate = (1 / (1 + riskRewardRatio)) * 100;

      setResponse({
        riskRewardRatioText: `1:${riskRewardRatio}`,
        riskRewardRatioValue: +riskRewardRatio.toFixed(2),
        breakevenWinRate: +breakevenWinRate.toFixed(2),
        breakevenWinRateText: `${breakevenWinRate.toFixed(2)}%`,
      });
    } catch (error) {
      alert.error(error?.message || "Somthing went wrong");
      console.log(error?.message);
    }
  }

  return (
    <div className="btcCalculatorSec">
      <h1 className="homeHeading text-center ">
        Risk Reward Ratio <span>Calculator</span>
      </h1>
      <div className="cCard">
        <div className="cCardInner">
          <div className="row ai-center ">
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={calculatorImg} alt="calculator" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form signup-form">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Entry Price</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="entryPrice"
                        placeholder="0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.entryPrice}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group">
                      <label>Stop Loss Price</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="slPrice"
                        placeholder="0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.slPrice}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label>Take Profit Price</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="tpPrice"
                        placeholder="0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.tpPrice}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <label>Trade Type</label>
                    <div className="form-group positive-relative">
                      <i className="fa-solid fa-caret-down  arrowDownIco" />

                      <select
                        onChange={(e) => onTextChange(e)}
                        name="tradeType"
                        placeholder="Long/Short"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.tradeType}
                      >
                        <option value="long">Long</option>
                        <option value="short">Short</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 text-center mt-1 mb-4">
                    {loader ? (
                      <button className="themeBtn ">
                        <i
                          className="fa fa-spinner fa-pulse mx-2 mb-1"
                          style={{ position: "relative", top: "-0px" }}
                        ></i>
                        Submit
                      </button>
                    ) : (
                      <button
                        className="themeBtn "
                        onClick={calculateRiskReward}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                  <div className="col-6 mb-4">
                    <div className="priceCard  ">
                      <div className="prCardInner">
                        <div className="title">Risk/Reward Ratio</div>
                        <div className="price">
                          {response?.riskRewardRatioText || 0}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 mb-4">
                    <div className="priceCard ">
                      <div className="prCardInner">
                        <div className="title">Profit/Loss</div>
                        <div className="price">
                          {response?.breakevenWinRateText || 0 + "%"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
